import { isArray } from '@dimjs/lang';
import { classNames } from '@dimjs/utils';
import { hooks } from '@wove/react';
import { cloneElement, ReactElement, useContext } from 'react';
import { CheckListContext, CheckListItemValue } from './context';

export type CheckListItemContentProps = {
  checked?: boolean;
  disabled?: boolean;
  onClick?: (event) => void;
  className?: string;
  readOnly?: boolean;
};

export type CheckListItemProps = {
  value: CheckListItemValue;
  disabled?: boolean;
  readOnly?: boolean;
  children?: string | ReactElement | ((data: CheckListItemContentProps) => ReactElement);
};

export const CheckListItem = (props: CheckListItemProps) => {
  const context = useContext(CheckListContext);

  if (context === null) {
    console.error('CheckList.Item can only be used inside CheckList.');
    return null;
  }

  const onClick = hooks.useCallbackRef((event) => {
    if (context.stopPropagation) {
      event.stopPropagation();
    }
    if (!props.disabled) {
      context?.onChange(props.value);
    }
  });

  const checked = context?.checkedValues.findIndex((temp) => temp === props.value) >= 0;
  const checkedClassPrefix = context.checkedClassPrefix;

  const innerClassName = classNames({
    [`${checkedClassPrefix}-disabled`]: props.disabled,
    [`${checkedClassPrefix}-readonly`]: props.readOnly,
    [`${checkedClassPrefix}-checked`]: checked,
  });

  if (typeof props.children == 'function') {
    return props.children({
      onClick,
      checked,
      disabled: props.disabled,
      readOnly: props.readOnly,
      className: innerClassName,
    });
  }

  const checkListItemDom = isArray(props.children) ? (
    <div className={`${checkedClassPrefix}-item-content-wrapper`}>{props.children}</div>
  ) : (
    props.children
  );

  return cloneElement(checkListItemDom as JSX.Element, {
    onClick,
    checked,
    disabled: props.disabled,
    readOnly: props.readOnly,
    className: classNames(checkListItemDom?.['props']?.className as string, innerClassName),
  });
};
